// useHasFeatureFlags.ts
import { FeatureFlag } from "@/constants";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useCallback } from "react";

type FeatureFlagChecker = (
    featureFlags: FeatureFlag[],
    selector?: "all" | "any" | "none",
) => boolean;

const useHasFeatureFlags = (): FeatureFlagChecker => {
    const flags = useFlags();

    return useCallback(
        (
            featureFlags: FeatureFlag[],
            selector: "all" | "any" | "none" = "all",
        ) => {
            if (!featureFlags.length) return true;
            switch (selector) {
                case "all":
                    return featureFlags.every((flag) => flags[flag]);
                case "any":
                    return featureFlags.some((flag) => flags[flag]);
                case "none":
                    return featureFlags.every((flag) => !flags[flag]);
            }
        },
        [flags],
    );
};

export default useHasFeatureFlags;
